import { BitrixVue } from 'ui.vue';
import './resultBlockImage.js';
import './resultBlockTop.js';
import './resultBlockCenter.js';
import './resultBlockBottom.js';

BitrixVue.component('ResultBlockItem', {
	data() {
		return {
			rowData: [],
		};
	},
	props: ['data', 'number'],
	created() {
		let rowData = [];

		const data = this.data;
		const keys = ['door', 'korob', 'insideFrames', 'ousideFrames', 'dobor', 'hinge', 'latch', 'handle','MoldingDesignColor'];


		//   if (item === "door") {
	    //     var _data$door;
	    //     var doorTitle = "Дверное полотно "+data.door.title;
	    //     var doorHeight = data.doorTypeCanvasHeight || "";
	    //     var doorWidth = data.doorTypeCanvasWidth || "";
	    //     var doorCover = data.doorCover.title || "";
	    //     // let doorsize = '';
	    //     // if (data.doorType.title === '') {
	    //     // }

	    //     var awidth = data.doorTypeCanvasWidth;
	    //     var aheight = data.doorTypeCanvasHeight;
	    //     var nacenka = 0;
	    //     if ((_data$door = data.door) !== null && _data$door !== void 0 && _data$door.nacenka) {
	    //       var _data$door2;
	    //       (_data$door2 = data.door) === null || _data$door2 === void 0 ? void 0 : _data$door2.nacenka.forEach(function (element) {
	    //         if (element.height == aheight && element.width == awidth) {
	    //           nacenka = element.price;
	    //         }
	    //       });
	    //     }
	    //     var doorSize = doorHeight && doorWidth ? "".concat(doorHeight, "x").concat(doorWidth) : "";
	    //     var doorGlazing = data.glazingType.title.toLowerCase() === "глухое" ? "глухое" : "".concat(data.glazingColor.title, ", ").concat(data.glazingGlass.title);
	    //     var dataParams = [data.door.price, data.doorCover.price, data.doorSizePrice.price];
	    //     if (doorGlazing !== "глухое") {
	    //       var _data$glazingColor, _data$glazingGlass;
	    //       dataParams.push((_data$glazingColor = data.glazingColor) === null || _data$glazingColor === void 0 ? void 0 : _data$glazingColor.price, data === null || data === void 0 ? void 0 : (_data$glazingGlass = data.glazingGlass) === null || _data$glazingGlass === void 0 ? void 0 : _data$glazingGlass.price);
	    //     }
	    //     var dataPrice = dataParams.reduce(function (accum, curr) {
	    //       if (curr !== undefined) {
	    //         accum += curr;
	    //         return accum;
	    //       }
	    //     }, 0);
	    //     if (nacenka > 0) {
	    //       dataPrice = dataPrice + dataPrice * nacenka;
	    //     }
	    //     var dataValue = "(".concat([doorSize, doorCover, doorGlazing].join(", "), ")");
	    //     var dataArr = {
	    //       title: doorTitle,
	    //       value: dataValue,
	    //       price: dataPrice
	    //     };
	    //     rowData.push(dataArr);
	    //   }
	    //   if (item === "insideFrames") {
	    //     if (data.doorFrameInside === undefined) return;
	    //     var insideFrameTitle = data.doorFrameInsideElement.full_title;
	    //     var insideFrameMolding = data.molding !== undefined ? data.molding.full_title.toLowerCase() : "";
	    //     var insideFrameCover = data.doorCover.title || "";
	    //     var countBlock = data.doorFrameInsideElement.kf;
	    //     var insideFrameCount = insideFrameTitle.toLowerCase() === "наличники" ? "".concat(countBlock, "\u0448\u0442.") : "2,5шт";
	    //     var _dataValue = "(".concat([insideFrameMolding, insideFrameCover, insideFrameCount].join(", "), ", ").concat(data.doorFrameInsideElement.razmer, ")");
	    //     var _dataParams = [];
	    //     if (data.doorFrameInsideElement !== undefined) {
	    //       _dataParams.push(data.doorFrameInsideElement.price);
	    //     }
	    //     var _dataPrice = _dataParams.reduce(function (accum, curr) {
	    //       if (curr !== undefined) {
	    //         accum += curr;
	    //         return accum;
	    //       }
	    //     }, 0);
	    //     var _dataArr = {
	    //       title: insideFrameTitle,
	    //       value: _dataValue,
	    //       price: _dataPrice
	    //     };
	    //     rowData.push(_dataArr);
	    //   }
	    //   if (item === "ousideFrames") {
	    //     if (data.doorFrameOutside === undefined) return;
	    //     var _insideFrameTitle = data.doorFrameOutsideElement.full_title;
	    //     var _insideFrameMolding = data.molding !== undefined ? data.molding.full_title.toLowerCase() : "";
	    //     var _insideFrameCover = data.doorCover.title || "";
	    //     var _countBlock = data.doorFrameOutsideElement ? data.doorFrameOutsideElement.kf : 1;
	    //     var _insideFrameCount = _insideFrameTitle.toLowerCase() === "наличники" ? "".concat(_countBlock, "\u0448\u0442.") : "2,5шт";
	    //     var _dataValue2 = "(".concat([_insideFrameMolding, _insideFrameCover, _insideFrameCount].join(", "), ", ").concat(data.doorFrameOutsideElement.razmer, ")");
	    //     var _dataParams2 = [];
	    //     if (data.doorFrameOutsideElement !== undefined) {
	    //       _dataParams2.push(data.doorFrameOutsideElement.price);
	    //     }
	    //     var _dataPrice2 = _dataParams2.reduce(function (accum, curr) {
	    //       if (curr !== undefined) {
	    //         accum += curr;
	    //         return accum;
	    //       }
	    //     }, 0);
	    //     var _dataArr2 = {
	    //       title: _insideFrameTitle,
	    //       value: _dataValue2,
	    //       price: _dataPrice2
	    //     };
	    //     rowData.push(_dataArr2);
	    //   }
	    //   if (item === "korob") {
	    //     if (data.molding === undefined) return;
	    //     var _countBlock2 = data.molding.kf;
	    //     var dataTitle = "Короб дверной";
	    //     var moldingColor = data.doorCover.title || "";
	    //     var moldingType = data.molding.title.toLowerCase();
	    //     var _dataValue3 = "(".concat(_countBlock2, "\u0448\u0442, ").concat([moldingType, moldingColor].join(", "), ", ").concat(data.molding.korob, ")");
	    //     var _dataPrice3 = data.molding.price || 0;
	    //     var _dataArr3 = {
	    //       title: dataTitle,
	    //       value: _dataValue3,
	    //       price: _dataPrice3
	    //     };
	    //     rowData.push(_dataArr3);
	    //   }
	    //   if (item === "handle") {
	    //     if (data._handleDesign === undefined) return;
	    //     var _dataTitle = "Ручка дверная " + data._handleDesign.title;
	    //     var _dataValue4 = "(1 \u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442, ".concat(data.handleDesignColor.title, ")");
	    //     var _dataParams3 = [];
	    //     if (data._handleDesign.price !== undefined) {
	    //       _dataParams3.push(data._handleDesign.price);
	    //     }
	    //     if (data.handleDesignColor.price !== undefined) {
	    //       _dataParams3.push(data.handleDesignColor.price);
	    //     }
	    //     var _dataPrice4 = _dataParams3.reduce(function (accum, curr) {
	    //       if (curr !== undefined) {
	    //         accum += curr;
	    //         return accum;
	    //       }
	    //     }, 0);
	    //     var _dataArr4 = {
	    //       title: _dataTitle,
	    //       value: _dataValue4,
	    //       price: _dataPrice4
	    //     };
	    //     rowData.push(_dataArr4);
	    //   }
	    //   if (item === "dobor") {
	    //     if (data.dobor === undefined) return;
	    //     var _countBlock3 = data.dobor.kf;
	    //     var _dataTitle2 = data.dobor.title;
	    //     var _dataValue5 = "(".concat(_countBlock3, "\u0448\u0442, ").concat(data.dobor.razmer, ")");
	    //     var _dataPrice5 = data.dobor.price;
	    //     var _dataArr5 = {
	    //       title: _dataTitle2,
	    //       value: _dataValue5,
	    //       price: _dataPrice5
	    //     };
	    //     rowData.push(_dataArr5);
	    //   }
	    //   if (item === "hinge") {
	    //     if (data.hingeType === undefined || data.hingeModel === undefined) return;
	    //     var _dataTitle3 = "Петли ";
	    //     var hingeCount = data.hingeAdditional !== undefined && data.hingeAdditional.need ? 3 : 2;
	    //     var hingeAdditionalPrice = data.hingeAdditional !== undefined && data.hingeAdditional.price ? data.hingeAdditional.price : 0;
	    //     var _dataValue6 = "(".concat(hingeCount + "шт.", ", ").concat(data.hingeType.title, ", ").concat(data.hingeModel.title, ")");
	    //     var _dataPrice6 = data.hingeModel.price + hingeAdditionalPrice;
	    //     var _dataArr6 = {
	    //       title: _dataTitle3,
	    //       value: _dataValue6,
	    //       price: _dataPrice6
	    //     };
	    //     rowData.push(_dataArr6);
	    //   }
	    //   if (item === "latch") {
	    //     if (data.latchModel === undefined) return;
	    //     var _dataTitle4 = "Защелка ";
	    //     var _dataValue7 = "(1\u0448\u0442, ".concat(data.latchModel.type.toLowerCase(), ", ").concat(data.latchModel.title, ")");
	    //     var _dataPrice7 = data.latchModel.price;
	    //     var _dataArr7 = {
	    //       title: _dataTitle4,
	    //       value: _dataValue7,
	    //       price: _dataPrice7
	    //     };
	    //     rowData.push(_dataArr7);
	    //   }
	    //   if (item === "latchZavertkaModel") {
	    //     var _data$latchZavertkaMo, _data$latchZavertkaMo2;
	    //     if (data.latchZavertkaModel === undefined) return;
	    //     var _dataTitle5 = (_data$latchZavertkaMo = data.latchZavertkaModel) === null || _data$latchZavertkaMo === void 0 ? void 0 : _data$latchZavertkaMo.full_title;
	    //     var _dataValue8 = "(1\u0448\u0442)";
	    //     var _dataPrice8 = (_data$latchZavertkaMo2 = data.latchZavertkaModel) === null || _data$latchZavertkaMo2 === void 0 ? void 0 : _data$latchZavertkaMo2.price;
	    //     var _dataArr8 = {
	    //       title: _dataTitle5,
	    //       value: _dataValue8,
	    //       price: _dataPrice8
	    //     };
	    //     //rowData.push(_dataArr8);
	    //   }

		keys.forEach((item) => {


			if (item === 'door') {
				const doorTitle = "Дверное полотно "+data.door.title;
				const doorHeight = data.doorTypeCanvasHeight || '';
				const doorWidth = data.doorTypeCanvasWidth || '';
				const doorCover = data.doorCover.title || '';
				// let doorsize = '';
				// if (data.doorType.title === '') {
				// }

				const doorSize = doorHeight && doorWidth ? `${doorHeight}x${doorWidth}` : '';
				const doorGlazing = data.glazingType.title.toLowerCase() === 'глухое' ? 'глухое' : `${data.glazingColor.title}, ${data.glazingGlass.title}`;
				const dataParams = [data.door.price, data.doorCover.price, data.doorSizePrice.price];
				if (doorGlazing !== 'глухое') {
					dataParams.push(data.glazingColor?.price, data?.glazingGlass?.price);
				}
				if (data.MoldingDesignColor) {
					dataParams.push(data.MoldingDesignColor?.price);
				}

				let dataPrice = dataParams.reduce((accum, curr) => {
					if (curr !== undefined) {
						accum += curr;
						return accum;
					}
				}, 0);
				let doorMolding = ``;
				if(data.MoldingDesignColor && data.MoldingDesignColor.id){

					doorMolding = `молдинг ${data.MoldingDesignColor.title}`
				}

				const dataValue = `(${[doorSize, doorCover, doorGlazing, doorMolding].join(', ')})`;
				const dataArr = {
					title: doorTitle,
					value: dataValue,
					price: dataPrice,
				};
				rowData.push(dataArr);
			}

			if (item === 'insideFrames') {
				if (data.doorFrameInside === undefined) return;

				const insideFrameTitle = data.doorFrameInsideElement.full_title;
				const insideFrameMolding = data.molding !== undefined ? data.molding.full_title.toLowerCase() : '';
				const insideFrameCover = data.doorCover.title || '';
				const insideFrameCount = insideFrameTitle.toLowerCase() === 'наличники' ? `${data.doorFrameInsideElement.kf}шт` : '2.5шт';
				const dataValue = `(${[insideFrameMolding, insideFrameCover, insideFrameCount].join(', ')})`;
				const dataParams = [];
				if (data.doorFrameInsideElement !== undefined) {
					dataParams.push(data.doorFrameInsideElement.price);
				}
				const dataPrice = dataParams.reduce((accum, curr) => {
					if (curr !== undefined) {
						accum += curr;
						return accum;
					}
				}, 0);
				const dataArr = {
					title: insideFrameTitle,
					value: dataValue,
					price: dataPrice,
				};

				rowData.push(dataArr);
			}
			if (item === 'ousideFrames') {
				if (data.doorFrameOutside === undefined) return;

	        	const _countBlock = data.doorFrameOutsideElement ? data.doorFrameOutsideElement.kf : 1;


				const insideFrameTitle = data.doorFrameOutsideElement.full_title;
				const insideFrameMolding = data.molding !== undefined ? data.molding.full_title.toLowerCase() : '';
				const insideFrameCover = data.doorCover.title || '';
				const insideFrameCount = insideFrameTitle.toLowerCase() === 'наличники' ? `${_countBlock}шт` : '2.5шт';
				const dataValue = `(${[insideFrameMolding, insideFrameCover, insideFrameCount].join(', ')})`;
				const dataParams = [];
				if (data.doorFrameOutsideElement !== undefined) {
					dataParams.push(data.doorFrameOutsideElement.price);
				}
				const dataPrice = dataParams.reduce((accum, curr) => {
					if (curr !== undefined) {
						accum += curr;
						return accum;
					}
				}, 0);
				const dataArr = {
					title: insideFrameTitle,
					value: dataValue,
					price: dataPrice,
				};

				rowData.push(dataArr);
			}

			if (item === 'korob') {
				if (data.molding === undefined) return;
				const dataTitle = 'Короб дверной';
				const moldingColor = data.doorCover.title || '';
				const moldingType = data.molding.title.toLowerCase();
				const dataValue = `(${data.molding.kf}шт, ${[moldingType, moldingColor].join(', ')})`;
				const dataPrice = data.molding.price || 0;
				const dataArr = {
					title: dataTitle,
					value: dataValue,
					price: dataPrice,
				};

				rowData.push(dataArr);
			}

			if (item === 'handle') {
				if (data._handleDesign === undefined) return;
				const dataTitle = 'Ручка дверная ' + data._handleDesign.title;
				const dataValue = `(2шт, ${data.handleDesignColor.title})`;

				const dataParams = [];

				if (data._handleDesign.price !== undefined) {
					dataParams.push(data._handleDesign.price);
				}
				if (data.handleDesignColor.price !== undefined) {
					dataParams.push(data.handleDesignColor.price);
				}
				const dataPrice = dataParams.reduce((accum, curr) => {
					if (curr !== undefined) {
						accum += curr;
						return accum;
					}
				}, 0);
				const dataArr = {
					title: dataTitle,
					value: dataValue,
					price: dataPrice,
				};

				rowData.push(dataArr);
			}

			if (item === 'dobor') {
				if (data.dobor === undefined) return;
				const dataTitle = data.dobor.title;
				const dataValue = `(${data.dobor.razmer})`;

				const dataPrice = data.dobor.price;
				const dataArr = {
					title: dataTitle,
					value: dataValue,
					price: dataPrice,
				};

				rowData.push(dataArr);
			}

			if (item === 'hinge') {
				if (data.hingeType === undefined || data.hingeModel === undefined) return;
				const dataTitle = 'Петли ';
				const hingeCount = data.hingeAdditional !== undefined && data.hingeAdditional.need ? 3 : 2;
				const hingeAdditionalPrice = data.hingeAdditional !== undefined && data.hingeAdditional.price ? data.hingeAdditional.price : 0;
				const dataValue = `(${hingeCount + 'шт.'}, ${data.hingeType.title}, ${data.hingeModel.title})`;
				const dataPrice = data.hingeModel.price + hingeAdditionalPrice;

				const dataArr = {
					title: dataTitle,
					value: dataValue,
					price: dataPrice,
				};

				rowData.push(dataArr);
			}
			if (item === 'latch') {
				if (data.latchModel === undefined) return;
				const dataTitle = 'Защелка ';
				const dataValue = `(${data.latchModel.type.toLowerCase()}, ${data.latchModel.title})`;
				const dataPrice = data.latchModel.price;

				const dataArr = {
					title: dataTitle,
					value: dataValue,
					price: dataPrice,
				};

				rowData.push(dataArr);
			}
		});



		// for (const key in this.data) {
		// 	if (Object.hasOwnProperty.call(this.data, key)) {
		// 		const element = this.data[key];
		// 		if (element && library[key]) {
		// 			let ar = {
		// 				title: library[key],
		// 				value: element.title,
		// 			};

		// 			if (key === 'doorTypeCanvasHeight' || key === 'doorTypeCanvasWidth') {
		// 				ar.value = element;
		// 			}
		// 			if (key === 'doorFrameInsideElement') {
		// 				ar.title = element.resultRowTitle;
		// 				ar.value = element.kf;
		// 			}

		// 			if (element.price) {
		// 				ar.price = element.price + ' руб.';
		// 			} else {
		// 				ar.price = 'Бесплатно';
		// 			}

		// 			rowData.push(ar);
		// 		}
		// 	}
		// }

		this.rowData = rowData;
	},
	template: `
	<div class="result-block__item">
        <ResultBlockImage :resultImage="data.renderImage" />
        <ResultBlockTop :doorName="data.positionDoorName" :doorAvailability="true" :basketId="number" />
        <ResultBlockCenter :rowData="rowData" />
        <ResultBlockBottom :totalAmount="data.totalAmount" />
	</div>
	`,
});
